















import { Component, Mixins, Inject } from "vue-property-decorator";
import { ICProdProvider } from "@/models/providers/contractProduct";
import { DataModules } from "@/store/modules/data";
import Context from "@/mixins/context";
import { IRoute } from "@/models/routes";

@Component
export default class SetupFieldsConfirmMessage extends Mixins(Context) {
  // Inject

  @Inject({ from: "contractProductProvider" })
  public readonly $cProdData!: () => ICProdProvider;

  // Computed

  public get cProdData() {
    return this.$cProdData();
  }

  public get cProdSetupRoute() {
    return this.$store.getters[
      `data/${DataModules.CONTRACTS_PRODUCTS}/routeToSetup`
    ](this.cProdData.contractProduct)?.to as IRoute["to"];
  }
}
